// All site text, one block per language. Keep both blocks in the same shape.
const translations = {
  en: {
    nav: {
      about: "About",
      contact: "Contact",
      openMenu: "Open menu",
      closeMenu: "Close menu",
      language: "Language",
    },
    home: {
      welcome: "Welcome to Frost Wyrm Studios!",
      intro: [
        "We are Frost Wyrm Studios, an indie game studio based in Frederico Westphalen, Brazil, bringing new experiences to the world of games since 2023. Our passion is creating immersive universes, full of challenges and captivating stories.",
        "Here, every pixel tells a story, and every mechanic is designed to provide unforgettable moments. Join us on this journey and discover what we’re creating!",
      ],
      comingSoon: "Coming Soon",
      outNow: "Out Now",
    },
    games: {
      littleMages3d: {
        badge: "Coming 2027",
        description:
          "Blast through undead hordes and build a devastating spell loadout in this retro first-person arena roguelite! Choose your mage, combine spells and perks, defeat bosses, and grow stronger between runs. Play solo or with up to 4 players in LAN co-op.",
        button: "Wishlist on Steam",
      },
      littleMages: {
        description:
          "Defend your castle from various hordes of enemies that seek to invade it! Little Mages is a casual pixel art game with roguelite elements where you accumulate knowledge and learn powerful spells of your choice to defeat all your enemies.",
        button: "View on Steam",
      },
    },
    about: {
      title: "About us",
      paragraphs: [
        "Frost Wyrm Studios is a newly founded indie game studio, born in 2023 in Frederico Westphalen, Brazil. Our journey began with a simple goal: to turn our passion for game development into unforgettable experiences for players.",
        "Currently, we have one game released, but our ambition goes far beyond that. Our next game, Little Mages 3D, is already in development and planned for 2027.",
        "Every project we create is built with dedication, aiming not only to entertain, but also to leave a lasting impression on those who play. We want our worlds to be explored, our stories to be lived, and every moment in our games to feel special.",
      ],
    },
    contact: {
      title: "Contact Us",
      text: "If you have any questions, feel free to send us an email. We’ll be happy to respond!",
      button: "Contact",
    },
    footer: {
      backToTop: "Back to top",
      rights: "All rights reserved.",
      instagram: "Instagram",
    },
    social: {
      instagram: "https://www.instagram.com/frostwyrm_en/",
    },
  },

  pt: {
    nav: {
      about: "Sobre",
      contact: "Contato",
      openMenu: "Abrir menu",
      closeMenu: "Fechar menu",
      language: "Idioma",
    },
    home: {
      welcome: "Bem-vindo à Frost Wyrm Studios!",
      intro: [
        "Somos a Frost Wyrm Studios, um estúdio de jogos independente de Frederico Westphalen, no Brasil, trazendo novas experiências para o mundo dos games desde 2023. Nossa paixão é criar universos imersivos, cheios de desafios e histórias cativantes.",
        "Aqui, cada pixel conta uma história e cada mecânica é pensada para proporcionar momentos inesquecíveis. Venha com a gente nessa jornada e descubra o que estamos criando!",
      ],
      comingSoon: "Em breve",
      outNow: "Disponível agora",
    },
    games: {
      littleMages3d: {
        badge: "Previsto para 2027",
        description:
          "Exploda hordas de mortos-vivos e monte um arsenal de feitiços devastador neste roguelite de arena retrô em primeira pessoa! Escolha seu mago, combine feitiços e perks, derrote chefes e fique mais forte entre as partidas. Jogue solo ou com até 4 jogadores em co-op LAN.",
        button: "Adicionar à lista de desejos",
      },
      littleMages: {
        description:
          "Defenda o seu castelo de diferentes hordas de inimigos que querem invadi-lo! Little Mages é um jogo casual em pixel art, com elementos de roguelite, onde você acumula conhecimento e aprende magias poderosas, à sua escolha, para derrotar todos os seus inimigos.",
        button: "Ver na Steam",
      },
    },
    about: {
      title: "Sobre nós",
      paragraphs: [
        "A Frost Wyrm Studios é um estúdio de jogos independente recém-fundado, nascido em 2023 em Frederico Westphalen, no Brasil. Nossa jornada começou com um objetivo simples: transformar nossa paixão pelo desenvolvimento de jogos em experiências inesquecíveis para os jogadores.",
        "Atualmente, temos um jogo lançado, mas nossa ambição vai muito além disso. Nosso próximo jogo, Little Mages 3D, já está em desenvolvimento e tem lançamento previsto para 2027.",
        "Cada projeto que criamos é feito com dedicação, buscando não apenas entreter, mas também deixar uma marca duradoura em quem joga. Queremos que nossos mundos sejam explorados, nossas histórias sejam vividas e que cada momento em nossos jogos seja especial.",
      ],
    },
    contact: {
      title: "Fale conosco",
      text: "Se tiver alguma dúvida, fique à vontade para nos enviar um e-mail. Teremos o maior prazer em responder!",
      button: "Contato",
    },
    footer: {
      backToTop: "Voltar ao topo",
      rights: "Todos os direitos reservados.",
      instagram: "Instagram",
    },
    social: {
      instagram: "https://www.instagram.com/frostwyrm_br/",
    },
  },
};

export default translations;
